<template>
  <div id="videos">
    <div id="videos-pc" class="flex flex-direction">
      <div class="top">
        <Title :ch="'精彩视频'"></Title>
      </div>
      <div class="video" v-if="nowVideo != null">
        <video
          style="border: 1px solid transparent"
          class="videoImg"
          ref="myVideo"
          :poster="nowVideo.showImagesRealPath[1]"
          :src="nowVideo.url"
          :controls="controls"
          controlslist="nodownload noremoteplayback"
          disablePictureInPicture
        ></video>
        <img
          class="pauseImg"
          :style="{ display: videoState ? 'none' : 'block' }"
          :src="VectorUrl"
          @click="didClick_pauseImg"
        />
      </div>
      <div class="video_list flex align-center swiper-no-swiping">
        <div class="swiper-container flex">
          <div class="swiper-wrapper-pc flex">
            <div
              class="swiper-slide-pc flex flex-direction align-center"
              v-for="(video, index) in videos"
              :key="index"
              @click="
                currentVideo = index;
                didClick_video();
              "
              @mouseenter="changeCurrent(index)"
            >
              <img
                class="swiper-img"
                :src="
                  $store.state.isMobile
                    ? video.showImagesRealPath[0]
                    : video.showImagesRealPath[1]
                "
                alt=""
                :style="{
                  borderColor: currentVideo == index ? '#B4251E' : '#dddddd',
                }"
              />
              <div
                class="swiper-text"
                :style="{
                  color: currentVideo == index ? '#B4251E' : '#333333',
                }"
              >
                {{ video.title }}
              </div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div
            class="swiper-button-prev-pc cs"
            v-if="videos.length > 4 && currentIndex !== 0"
            @click="prevSwiper"
          >
            <img :src="ArrowUrl" />
          </div>
          <div
            class="swiper-button-next-pc cs"
            v-if="videos.length > 4 && currentIndex < videos.length - 4"
            @click="nextSwiper"
          >
            <img :src="ArrowUrl" />
          </div>
        </div>
      </div>
      <!--      <div class="link flex align-center justify-center cs">-->
      <!--        <span @click="lookMore"> 查看更多 >></span>-->
      <!--      </div>-->
      <DidLink @click.native="lookMore"></DidLink>
    </div>
    <div id="videos-wap">
      <div class="top">
        <Title :ch="'精彩视频'" :bg-img="titleBgImg"> </Title>
      </div>
      <div class="list flex flex-direction">
        <div class="swiper-container-video-wap flex">
          <div class="swiper-wrapper flex">
            <div
              class="swiper-slide flex"
              style="
                transform: translate3d(0, 0, 0);
                overflow: hidden;
                width: 100%;
                height: calc(100% - 30px);
              "
              v-for="(video, index) in videos"
              :key="index"
              @mouseenter="currentVideo = index"
              @click="currentVideo = index"
            >
              <div
                class="slide flex flex-direction"
                @click="didClick_deve(video)"
              >
                <div class="top-video">
                  <img
                    class="top-video_videoImg"
                    :src="
                      $store.state.isMobile
                        ? video.showImagesRealPath[0]
                        : video.showImagesRealPath[1]
                    "
                  />
                  <img class="top-video_pauseImg" :src="VectorUrl" />
                </div>
                <div class="title-box">
                  <div class="title">{{ video.title }}</div>
                </div>
              </div>
            </div>
          </div>
          <!--     小圆点分页器       -->
          <div
            class="swiper-pagination-video-wap flex align-center justify-center"
            slot="pagination"
            style="width: 100%; height: 20px"
          ></div>
        </div>
      </div>
      <DidLink @click.native="lookMore"></DidLink>
      <!--      <div class="link flex align-center justify-center cs">-->
      <!--        <span @click="lookMore"> 查看更多 >></span>-->
      <!--      </div>-->
      <video-player
        v-if="wapSelectVideo"
        :propsData="{ ...nowVideo }"
        @changeSelectVideo="changeSelectVideo"
      ></video-player>
    </div>
  </div>
</template>

<script>
import Title from "./common/Title";
import VideoPlayer from "./common/VideoPlayer";
import { Swiper } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { staticApi } from "../services";
import $store from "../store";
import _ from "lodash";
var self;
export default {
  name: "videos",
  data() {
    return {
      rightArrowUrl: require("../assets/images/developer/rightArrow.png"),
      VectorUrl: require("../assets/images/videos/pause.png"),
      ArrowUrl: require("../assets/images/videos/arrow.png"),
      titleBgImg: require("../assets/images/wap/title/videos.png"),
      currentVideo: 0,
      currentIndex: 0,
      timer: null,
      nowVideo: null,
      videos: [],
      swiper_video_pc: null,
      swiper_video_wap: null,
      videoState: false, //视频是否播放中
      wapSelectVideo: false,
      controls: false, //pc播放器 是否有控件
      swiperOption_video_pc: {},
    };
  },
  components: {
    Title,
    VideoPlayer,
  },
  created() {
    self = this;
    this.getVideosList();
  },
  // swiper6属性配置,在生命周期mounted中，动态数据把下面的配置放到获取数据的后面执行即可
  mounted() {
    self = this;
    this.$bus.$on("reSwiper", (res) => {
      //初始化 swiper 方法 ↓
      var h = document.documentElement.clientWidth; //获取页面可见高度
      if (h < 992) {
        if (this.swiper_video_wap) {
          this.swiper_video_wap.init();
        }
      } else {
        this.swiper_video_pc.init();
      }
    });
  },
  methods: {
    prevSwiper() {
      if (this.currentIndex <= 0) {
        return;
      }
      if (this.currentIndex < this.videos.length - 1) {
        this.currentIndex = this.currentIndex - 1;
        const currentItem =
          document.getElementsByClassName("swiper-slide-pc")[this.currentIndex];
        const container =
          document.getElementsByClassName("swiper-wrapper-pc")[0];
        if (this.currentIndex == 0) {
          container.style.marginLeft = "0px";
        } else {
          container.style.marginLeft =
            -currentItem.offsetWidth * this.currentIndex + "px";
        }
      }
    },
    nextSwiper() {
      if (this.currentIndex >= this.videos.length - 1) {
        return;
      }
      if (this.currentIndex < this.videos.length - 4) {
        this.currentIndex = this.currentIndex + 1;
        const currentItem =
          document.getElementsByClassName("swiper-slide-pc")[this.currentIndex];
        const container =
          document.getElementsByClassName("swiper-wrapper-pc")[0];
        container.style.marginLeft =
          "-" + currentItem.offsetWidth * this.currentIndex + "px";
      }
    },
    changeCurrent(index) {
      if (index >= 0) {
        this.realIndex = _.cloneDeep(this.currentVideo);
        this.currentVideo = index;
      } else {
        this.currentVideo = _.cloneDeep(this.realIndex);
      }
    },
    clkItem(index, realIndex) {
      // console.warn('==>>click loop item title = ' + this.showLoopValues[realIndex]['id']);
    },
    handleClickSlide(index) {},
    enter(e) {
      const nowIndex =
        e.toElement.getAttribute("data-swiper-slide-index") ||
        e.toElement.getAttribute("data-index");
      this.currentVideo = nowIndex;
    },
    leave() {
      // this.$refs.mySwiper.swiper.autoplay.start()
    },
    //获取精彩视频列表
    getVideosList() {
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.seminarId}/article/list/${this.$config.videosId}.json`
        )
        .then((res) => {
          if (res.result === 0) {
            const videos = res.content.items;
            for (const item of videos) {
              if (item.showImagesRealPath.length == 1) {
                item.showImagesRealPath[1] = item.showImagesRealPath[0];
              }
              if (item.showImagesRealPath[0]) {
                item.showImagesRealPath[0] = item.showImagesRealPath[0].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
              if (item.showImagesRealPath[1]) {
                item.showImagesRealPath[1] = item.showImagesRealPath[1].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
            }
            //筛选
            let newsList1 = videos.filter((a) => {
              return a.isRecommend == 1;
            });
            //排序
            newsList1.sort((a, b) => {
              return b.pushTime - a.pushTime;
            });
            //位置排序
            newsList1.sort((a, b) => {
              return b.order - a.order;
            });
            this.videos = newsList1;
            this.nowVideo = newsList1[0];
            this.ListenVideo();
            this.$nextTick(() => {
              // 初始化swiper
              this.loadSwiper();
              this.$bus.$emit("ready", "videos");
            });
          }
        })
        .catch((err) => {
          console.error("获取列表失败", err);
        });
    },
    //点击播放
    didClick_pauseImg() {
      const option = this.nowVideo;
      if (this.$refs.myVideo.paused) {
        this.$refs.myVideo.play();
        this.videoState = true;
        this.controls = true;
        window._hw("send", "action", "index_video_play_click", {
          video_name: option.title, // 内容名称
          product_tag: option.tags[0] ? option.tags[0].name : "", //产品标签
          industry_tag: option.tags[1] ? option.tags[1].name : "", //行业标签
          solution_tag: option.tags[2] ? option.tags[2].name : "", //解决方案标签
          hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
        });
        //完成任务
        this.$store.dispatch("interaction/onCompleteTask", {
          desc: "精彩瞬间",
          objectId: this.nowVideo.id,
        });
      } else {
        this.$refs.myVideo.pause();
        this.videoState = false;
        this.controls = false;
      }
    },
    //点击视频 pc
    didClick_video() {
      let player = this.$refs.myVideo;
      player.src = this.nowVideo.url;
      player.poster = this.nowVideo.showImagesRealPath[1];
      this.videoState = false;

      window._hw("send", "action", "index_video_play_click", {
        video_name: this.nowVideo.title, // 内容名称
        product_tag: this.nowVideo.tags[0] ? this.nowVideo.tags[0].name : "", //产品标签
        industry_tag: this.nowVideo.tags[1] ? this.nowVideo.tags[1].name : "", //行业标签
        solution_tag: this.nowVideo.tags[2] ? this.nowVideo.tags[2].name : "", //解决方案标签
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
    },
    //监听video
    ListenVideo() {
      //若是手机 加载视频
      if ($store.state.isMobile) {
        return;
      }
      // 监听视频播放
      this.$nextTick(function () {
        this.$refs.myVideo.addEventListener("play", () => {
          this.videoState = true;
        });
        // 监听视频暂停
        this.$refs.myVideo.addEventListener("pause", () => {
          this.videoState = false;
        });
        this.$refs.myVideo.addEventListener("ended", () => {
          this.controls = false;
          this.$refs.myVideo.load();
        });
      });
    },
    loadSwiper() {
      const h = document.documentElement.clientWidth; //获取页面可见宽度
      if (h <= 992) {
        this.swiper_video_wap = new Swiper(".swiper-container-video-wap", {
          loop: true, //首尾循环
          // centeredSlides: false,
          // loopedSlides: 10,
          // slidesPerView: 1.19, //每组 有多少块
          // spaceBetween: 15, //板块间隔
          // slidesPerGroup: 1, //多少个板块为1组。
          slidesPerView: "auto",
          centeredSlides: true,
          pagination: {
            el: ".swiper-pagination-video-wap",
            clickable: true,
            bulletClass: "my-bullet",
            bulletActiveClass: "my-bullet-active2",
          },
          on: {
            click(e) {
              const realIndex = this.realIndex;
              self.didClick_deve(self.videos[realIndex]);
            },
          },
        });
      } else {
        // this.swiper_video_pc = new Swiper(".swiper-container", {
        //   loop: true, //首尾循环
        //   centeredSlides: false,
        //   loopedSlides: 10,
        //   spaceBetween: 12, //块 间隔
        //   slidesPerView: 4,
        //   navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev",
        //   },
        //   resistanceRatio: 0,
        //   on: {
        //     click: (e) => {
        //       const realIndex = this.realIndex;
        //       console.log("当前下标", realIndex);
        //     },
        //   },
        // });
      }
    },
    //查看更多 二级列表页
    lookMore() {
      window._hw("send", "action", "index_check_more_all_click", {
        module_name: "精彩视频",
      });
      this.$router.push({
        path: "/video-list",
      });
    },
    didClick_deve(option) {
      this.nowVideo = option;
      this.wapSelectVideo = true;
      window._hw("send", "action", "index_video_play_click", {
        video_name: option.title, // 内容名称
        product_tag: option.tags[0] ? option.tags[0].name : "", //产品标签
        industry_tag: option.tags[1] ? option.tags[1].name : "", //行业标签
        solution_tag: option.tags[2] ? option.tags[2].name : "", //解决方案标签
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
      //完成任务
      this.$store.dispatch("interaction/onCompleteTask", {
        desc: "精彩瞬间",
        objectId: this.nowVideo.id,
      });
    },
    //关闭 wap 视频播放器
    changeSelectVideo() {
      this.wapSelectVideo = false;
    },
  },
  watch: {
    currentVideo(newVal, oldVal) {
      this.nowVideo = this.videos[newVal];
    },
    showSwiper(newVal, oldVal) {},
  },
};
</script>

<style lang="scss" scoped>
//videos begin
#videos-pc {
  display: none;
}
#videos-wap {
  display: none;
}
@media screen and (max-width: 992px) {
  #videos-wap {
    display: block;
    width: 100%;
    padding-top: 143px;
    .top {
      width: 100%;
    }
    .list {
      width: 100%;
      height: 543px;
      overflow: hidden;
      ::v-deep .swiper-container-video-wap {
        position: relative;
        width: 100%;
        height: 100%;
        .swiper-slide {
          width: 80% !important;
          margin: 0 2%;
        }
        .swiper-slide-active {
          transition: 200ms;
          transform: scale(1) !important;
        }
        .swiper-slide-prev {
          right: -4%;
          transition: 200ms;
          transform: scale(0.9) !important;
        }
        .swiper-slide-next {
          left: -4%;
          transition: 200ms;
          transform: scale(0.9) !important;
        }
        .swiper-pagination-video-wap {
          position: absolute;
          bottom: 0px;
          left: 0;
          z-index: 10;
        }
        .my-bullet {
          width: 26px;
          height: 8px;
          background: #c4c4c4;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          margin: 0 5px;
        }
        .my-bullet-active2 {
          background: #b4251e;
        }
      }
      .slide {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        position: relative;
        transform: translate3d(0, 0, 0);
        .top-video {
          width: 100%;
          height: 320px;
          position: relative;
          .top-video_videoImg {
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
          .top-video_pauseImg {
            width: 67px;
            height: 67px;
            border-radius: 50%;
            position: absolute;
            top: calc(50% - 33px);
            left: calc(50% - 33px);
          }
        }
        .title-box {
          height: 158px;
          background: rgba(255, 255, 255, 0.3);
          opacity: 1;
          .title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            width: 100%;
            height: 100%;
            font-size: 28px;
            box-sizing: border-box;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;

            color: #151e26;
            padding: 30px 54px 0 40px;
            background: rgba(255, 255, 255, 0.3)
              linear-gradient(
                147deg,
                rgba(255, 255, 255, 0) 0%,
                #ffffff 50%,
                rgba(255, 255, 255, 0) 100%
              );
            opacity: 1;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 992px) {
  #videos-pc {
    display: block;
    width: 1920px;
    padding-top: 60px;
    padding-bottom: 60px;
    .top {
      margin-left: 160px;
      width: 1158px;
      margin-bottom: 4px; //保持和 沙箱实验室 距离标题高度一致
    }

    .video {
      width: 1596px;
      height: 900px;
      margin: 0 auto;
      margin-bottom: 10px;
      position: relative;
      .videoImg {
        width: 100%;
        height: 100%;
        outline: 0 !important;
      }

      .pauseImg {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        position: absolute;
        top: calc(50% - 60px);
        left: calc(50% - 60px);
      }
    }

    .video_list {
      width: 1596px;
      margin: 0 auto;
      margin-top: 11px;

      .swiper-container {
        width: 1600px;
        height: 100%;
        position: relative;
        overflow-x: hidden;
        overflow-y: auto;
        .swiper-wrapper-pc {
          width: 100%;
          padding-left: 1px;

          .swiper-slide-pc {
            width: 25%;
          }
          @media screen and (-ms-high-contrast: active),
            (-ms-high-contrast: none) {
            /*兼容IE11*/
            .swiper-slide-pc {
              width: auto;
            }
          }

          .swiper-img {
            width: 394px;
            height: 230px;
            border: 2px solid transparent;
          }

          .swiper-text {
            width: 400px;
            padding-left: 10px;
            padding-right: 10px;
            margin-top: 20px;
            font-size: $font-xxl;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
            height: 24px;
            color: #333333;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
        }
        .swiper-button-prev-pc {
          width: 69px;
          height: 69px;
          background: #151e26;
          opacity: 0.7;
          position: absolute;
          top: 100px;
          left: 191px;
          border-radius: 50%;
          line-height: 69px;
          text-align: center;
          &::after {
            content: "";
          }
          img {
            width: 25px;
            height: 20px;
            transform: rotate(90deg);
          }
        }

        .swiper-button-next-pc {
          width: 69px;
          height: 69px;
          opacity: 0.7;
          position: absolute;
          top: 100px;
          right: 191px;
          background-color: #151e26;
          border-radius: 50%;
          line-height: 69px;
          text-align: center;
          &::after {
            content: "";
          }
          img {
            width: 25px;
            height: 20px;
            transform: rotate(270deg);
          }
        }
      }

      .hoverVideo {
        color: #b4251e;
        width: 583px;
        height: 201px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .img {
          width: 301px;
          height: 168px;
          position: relative;

          .videoImg {
            width: 301px;
            height: 168px;
            border-radius: 20px 20px 20px 20px;
            position: absolute;
            top: 0;
            left: 0;
          }

          .pauseImg {
            width: 38px;
            height: 34px;
            position: absolute;
            top: 67px;
            left: 131px;
          }
        }

        .describe {
          height: 168px;

          .text {
            width: 210px;
            height: 78px;
            font-size: 18px;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
            color: #151e26;
            line-height: 26px;
          }
          .link {
            width: 70px;
            height: 24px;
            font-size: 12px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;

            color: #b4251e;
            line-height: 24px;

            img {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}

//videos end
</style>
